<mat-toolbar color="accent">
	<mat-toolbar-row>
		<span>
			{{ subTitle }}
		</span>
		<span class="spacer"></span>
		<button mat-raised-button type="button" aria-label="Edit" (click)="handleBack()">
			<mat-icon>chevron_left</mat-icon>
		</button>
	</mat-toolbar-row>
</mat-toolbar>

<form [formGroup]="fieldForm" *ngIf="isFormLoaded()" (ngSubmit)="handleSubmit()" class="flex-item flex-container">

	<div class="field-container">
		<div class="field-item field-full field-md-half">
			<label>Table Name</label>
			<span>{{ field.table_name }}</span>
		</div>

		<div class="field-item field-full field-md-half">
			<label>Field Name</label>
			<span>{{ field.field_name }}</span>
		</div>
	</div>

	<div class="field-container">
		<mat-slide-toggle formControlName="display_field" class="slider-toggle field-full field-sm-half" >Display this field on view and edit screens?</mat-slide-toggle>
		<mat-slide-toggle formControlName="require_field" class="slider-toggle field-full field-sm-half" >Require this field to be filled?</mat-slide-toggle>
	</div>

	<div class="field-container justify-end form-controls">
		<button
			class="field-full field-sm-auto"
			[disabled]="getIsSubmitActive()"
			name="button-submit"
			mat-raised-button
			type="submit"
			color="primary">
			<span>Save</span>
		</button>

	</div>

</form>
